// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import Events from "events";

function CreateEmitter(T) {
  var messageConstant = "ON_MESSAGE_";
  var ev = new Events();
  var on = function (param) {
    var msgHandler = Curry.__1(param);
    ev.on(messageConstant, msgHandler);
    return msgHandler;
  };
  var emit = function (param) {
    ev.emit(messageConstant, param);
  };
  var removeAllListeners = function (param) {
    ev.removeAllListeners();
  };
  var removeListener = function (listener) {
    ev.removeListener(messageConstant, listener);
  };
  var listenerCount = function (param) {
    return ev.listenerCount(messageConstant);
  };
  return {
          messageConstant: messageConstant,
          ev: ev,
          on: on,
          emit: emit,
          removeAllListeners: removeAllListeners,
          removeListener: removeListener,
          listenerCount: listenerCount
        };
}

export {
  CreateEmitter ,
}
/* events Not a pure module */
